export default "__VITE_ASSET__92e051e4__"